import React from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import Config from "Data"
import moment from "moment"

const SEO = ({ title, description, keywords, banner, pathname, article, events, indexed }) => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: {
          defaultTitle,
          titleAlt,

          brand,

          siteLanguage,

          siteKeywords,
          siteUrl,

          defaultDescription,
          defaultBanner,

          twitterHandle,
        },
      },
    }) => {
      let mergedKeywords = siteKeywords.concat(keywords)
      const seo = {
        title: title || defaultTitle,
        description: description ? `${description} | ${defaultDescription}` : defaultDescription,
        keywords: mergedKeywords.join(","),
        image: `${siteUrl}${banner || defaultBanner}`,
        url: `${siteUrl}${pathname.toString().replace(/\s+/g, "-").toLowerCase() || "/"}`,
      }
      let schemaOrgJSONLD = []
      let schemaSocialMedia = []
      Config.socialMedia.map((socialMediaObject) => {
        if (socialMediaObject.url) {
          schemaSocialMedia.push(socialMediaObject.url)
        }
      })

      // schemaOrgJSONLD = [
      //   {
      //     "@context": "http://schema.org",
      //     "@type": "Organization",
      //     legalName: `${Config.contact.legalName}`,
      //     contactPoint: [
      //       {
      //         "@type": "ContactPoint",
      //         telephone: `${Config.contact.phone.us}`,
      //         contactType: "Customer Service",
      //       },
      //     ],
      //     sameAs: schemaSocialMedia,
      //     itemListElement: [
      //       {
      //         "@type": "SiteNavigationElement",
      //         "@id": "#table-of-contents",
      //         position: 1,
      //         name: "Events Calendar",
      //         description: "Interested in attending one of our upcoming events?",
      //         url: `${siteUrl}/events`,
      //       },
      //     ],
      //     "@id": seo.url,
      //     name: `${seo.title}`,
      //     url: seo.url,
      //     description: seo.description,
      //     alternateName: titleAlt || "",
      //     image: {
      //       "@type": "ImageObject",
      //       url: seo.image,
      //     },
      //     headline: seo.title,
      //     author: {
      //       "@type": "Organization",
      //       name: author,
      //     },
      //     publisher: {
      //       "@type": "Organization",
      //       name: author,
      //       logo: {
      //         "@type": "ImageObject",
      //         url: siteUrl + "/" + logo,
      //       },
      //     },
      //     isPartOf: siteUrl,
      //     mainEntityOfPage: {
      //       "@type": "Website",
      //       "@id": siteUrl,
      //     },
      //   },
      // ]
      if (events) {
        let futureEvents = events.filter((event) => {
          return !moment(event.node.date).isBefore(moment(), "day")
        })
        futureEvents.sort((a, b) => (a.node.date > b.node.date ? 1 : -1))

        futureEvents.map((event) => {
          if (event.node.eventSite) {
            // {
            //   "@context": "https://schema.org",
            //   "@type": "Event",
            //   "name": `${event.node.events}`,
            //   "startDate": `${event.node.date}`,
            //   "endDate": `${event.node.date}`,
            //   "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
            //   "eventStatus": "https://schema.org/EventScheduled",
            //   "location": {
            //     "@type": "Place",
            //     "name": `${event.node.city}`,
            //     "address": {
            //       "@type": "PostalAddress",
            //       "streetAddress": `${event.node.city}`,
            //     }
            //   },
            //   "image": [
            //     "https://example.com/photos/1x1/photo.jpg",
            //     "https://example.com/photos/4x3/photo.jpg",
            //     "https://example.com/photos/16x9/photo.jpg"
            //    ],
            //   "description": "The Adventures of Kira and Morrison is coming to Snickertown in a can’t miss performance.",
            //   "offers": {
            //     "@type": "Offer",
            //     "url": "https://www.example.com/event_offer/12345_201803180430",
            //     "price": "30",
            //     "priceCurrency": "USD",
            //     "availability": "https://schema.org/InStock",
            //     "validFrom": "2024-05-21T12:00"
            //   },
            //   "performer": {
            //     "@type": "PerformingGroup",
            //     "name": "Kira and Morrison"
            //   },
            //   "organizer": {
            //     "@type": "Organization",
            //     "name": `${Config.contact.legalName}`,
            //     "url": `${siteUrl}`
            //   }
            // }

            schemaOrgJSONLD.push({
              "@context": "http://schema.org",
              "@type": "Event",
              name: `${event.node.eventTitle}`,
              url: `${event.node.eventSite}`,
              description: `Interested in attending ${event.node.eventTitle}?`,
              alternateName: `${event.node.brand} ${event.node.city}`,
              eventAttendanceMode: `${event.node.eventType === "conference"
                  ? "https://schema.org/OfflineEventAttendanceMode"
                  : "https://schema.org/OnlineEventAttendanceMode"
                }`,
              eventStatus: `http://schema.org/EventScheduled`,
              image: {
                "@type": "ImageObject",
                url: `${event.node.image ? event.node.image : ""}`,
              },
              location: {
                "@type": "Place",
                name: `${event.node.city}`,
                address: {
                  "@type": "PostalAddress",
                  addressLocality: `${event.node.city}`,
                },
              },
              startDate: `${event.node.date}`,
              endDate: `${event.node.date}`,
              potentialAction: "Participation",
              organizer: {
                "@type": "Organization",
                legalName: `${Config.contact.legalName}`,
                // contactPoint: {
                //   "@type": "ContactPoint",
                //   telephone: `${Config.contact.phone.us}`,
                //   contactType: "Customer Service",
                // },
                // image: {
                //   "@type": "ImageObject",
                //   url: seo.image,
                // },
                sameAs: schemaSocialMedia,
                "@id": seo.url,
                name: `${seo.title}`,
                url: seo.url,
                description: seo.description,
                alternateName: titleAlt || "",
              },
            })
          }
        })
      }
      return (
        <>
          <Helmet defer={false} title={seo.title}>
            <html lang={siteLanguage} />
            <meta name="description" content={seo.description} />
            <meta name="google-site-verification" content={Config.googleVerification} />
            <meta name="keywords" content={seo.keywords} />
            <meta name="image" content={seo.image} />

            {
              indexed ?
                (<meta name="robots" content="index,follow" />) :
                (<meta name="robots" content="noindex,nofollow" />)
            }
            {/* <meta name="robots" content="index,follow" /> */}
            {/* {(() => {
              switch (process.env.NODE_ENV) {
                case "development":
                  return <meta name="robots" content="index,follow" />
                case "production":
                  return <meta name="robots" content="noindex,nofollow" />
                default:
                  return ""
              }
            })()} */}
            <meta name="apple-mobile-web-app-title" content={brand} />
            <meta name="application-name" content={brand} />
            {/* OpenGraph  */}
            <meta property="og:url" content={seo.url} />
            <meta property="og:type" content={article ? "article" : null} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content={seo.image} />
            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:creator" content={`${twitterHandle}`} />
            {/* <meta name="twitter:site" content={seo.title} /> */}
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
            {/* ld+json */}
            <script type="application/ld+json">{JSON.stringify(schemaOrgJSONLD)}</script>
          </Helmet>
        </>
      )
    }}
  />
)
//   }
// }

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  banner: PropTypes.string,
  pathname: PropTypes.string,
  article: PropTypes.bool,
  event: PropTypes.object,
}

SEO.defaultProps = {
  title: null,
  desc: null,
  banner: "",
  pathname: null,
  article: true,
  event: null,
  indexed: true
}

const query = graphql`
  query SEO {
    site {
      buildTime(formatString: "YYYY-MM-DD")
      siteMetadata {
        defaultTitle: title
        titleAlt
        siteTitle
        brand
        author
        siteLanguage
        logo
        siteKeywords
        siteUrl: url
        pathPrefix
        defaultDescription: description
        defaultBanner: banner
        twitterHandle
      }
    }
  }
`
